import { React } from 'react';
import i18n from '../locales/i18n';

export default function LangButton() {
  const languageOption = i18n.language === 'pt' ? 'es' : 'pt';

  return (
    <button
      type="button"
      className="buttonLanguage"
      onClick={() => i18n.changeLanguage(languageOption)}
    >
      {languageOption === 'pt' ? 'PT' : 'ES'}
    </button>
  );
}
